import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';
import TextButton from 'components/TextButton';
import TheoData from 'components/TheoData';
import TimeSince from 'components/TimeSince';
import { fromIso9075DateString } from 'utils/dates';
import { cmDisplayName } from 'utils/roles';
import { wallPostShape } from 'utils/shapes';
import './PostAuthor.css';

function PostAuthor({ post, link, linkAlt, adminView, showLegacyFeed }) {
  const [show, setShow] = useState(false);
  const target = useRef();

  let author = cmDisplayName(post.author);
  if (link) {
    const authorButton = (
      <TextButton ref={target} onClick={() => setShow(!show)}>
        {author}
      </TextButton>
    );
    author = (
      <>
        {authorButton}
        <Overlay
          rootClose={true}
          rootCloseEvent="Click"
          onHide={() => setShow(!show)}
          target={target.current}
          show={show}
          placement="bottom"
        >
          <Tooltip className="post-author-tooltip" id="post-author-tooltip">
            <TheoData
              link={link}
              linkAlt={linkAlt}
              userId={post.author.userId}
              onClick={() => setShow(!show)}
            />
          </Tooltip>
        </Overlay>
      </>
    );
  }

  let timestamp = post.created;
  let prefix = 'posted';

  if (post.lastEditedAt) {
    timestamp = post.lastEditedAt;
    prefix = 'edited';
  }

  const authorMessageClassName = showLegacyFeed
    ? 'legacy-feed-message-author-container'
    : 'feed-message-author-container';

  return (
    <div className={authorMessageClassName}>
      <div
        className="feed-message-author-name notranslate"
        title={post.author.displayName}
        aria-hidden="true"
      >
        {author}
      </div>
      <span className="sr-only notranslate">{post.author.displayName}</span>
      <div className="post-time">
        <TimeSince date={fromIso9075DateString(timestamp)} prefix={prefix} />
        <span>{post.device && ' from ' + post.device}</span>
        <span>
          {adminView && post.deviceInfo && ' [' + post.deviceInfo + ']'}
        </span>
      </div>
    </div>
  );
}

PostAuthor.propTypes = {
  post: wallPostShape,
  link: PropTypes.string,
  adminView: PropTypes.bool,
  showLegacyFeed: PropTypes.bool
};

export default PostAuthor;
